export enum DateTimePeriod {
  Last7Days = 'Last 7 Days',
  Last30Days = 'Last 30 Days',
  Last90Days = 'Last 90 Days',
  ThisWeek = 'This Week',
  LastWeek = 'Last Week',
  ThisMonth = 'This Month',
  LastMonth = 'Last Month',
  Last12Months = 'Last 12 Months',
  ThisQuarter = 'This Quarter',
  LastQuarter = 'Last Quarter',
  ThisYear = 'This Year',
  LastYear = 'Last Year',
}
